import { Alert } from "../alerts/alert";
import { Tag } from "@models/common/tag";
import { IndividualRecordShort } from "./individual-record-short";
import { IndividualVerificationStatus } from "./individual-verification-status";

export class IndividualRecord extends IndividualRecordShort{
    email: string;
    phone: string;
    alerts: Alert[] = [];
    tags: Tag[] = [];
    warningStatesTags: Tag[] = [];
    tagsName: string[] = [];
    warningStatesName: string[] = [];
    customTags: Tag[] = [];
    verificationStatus: IndividualVerificationStatus;


    constructor(init: Partial<IndividualRecord> = {}) {
        super(init);
        this.email = init?.email ?? '';
        this.phone = init?.phone ?? '';
        this.alerts = (init?.alerts ?? []).map(alert => new Alert(alert));
        this.customTags = (init?.customTags ?? []).map(tag => new Tag(tag));
        this.tagsName = init?.tagsName ?? [];
        this.warningStatesName = init?.warningStatesName ?? [];
        this.warningStatesTags = (init?.warningStatesTags ?? []).map(tag => new Tag(tag));
        this.tags = this.warningStatesTags.length > 0 ?  this.customTags.concat(this.warningStatesTags) : this.customTags;
        this.verificationStatus = init?.verificationStatus ?? IndividualVerificationStatus.NotVerified;
    }
}
